import { render, staticRenderFns } from "./Discord.vue?vue&type=template&id=92789c36&scoped=true&"
import script from "./Discord.vue?vue&type=script&lang=js&"
export * from "./Discord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92789c36",
  null
  
)

export default component.exports